import { Tag, TagLabel } from "@chakra-ui/react";

export function CustomClaimTag({ label }) {
  return (
    <Tag
      size="md"
      key="md"
      borderRadius="full"
      variant="solid"
      sx={{ 
        background: label === "claimed" ? "#25D366" : "linear-gradient(180deg, #9BA5D2 0%, #3A50AC 100%)",
      }}
      // colorScheme={label === "claimed" ? "whatsapp" : "blue"}
    >
      <TagLabel>{label}</TagLabel>
    </Tag>
  );
}
